import React, { useState, useEffect } from "react";
import TopNav from "../layouts/TopNav";
import "../Styles/loading.css";
import "../Styles/slip.css";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { BsArrowLeft } from "react-icons/bs";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

type Invoice = {
  businessName: string;
  _id: string;
  customer: string;
  loadingSlip: any;
};

type Transport = {
  driver: string;
  _id: string;
  capacity: string;
  plateNumber: any;
};

interface LicenseData {
  licenseId: string;
  licenseOwner: string;
  destination: string;
}

const Slip = () => {
  const [reLogin, setReLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [licenseData, setLicenseData] = useState<LicenseData>({
    licenseId: "",
    licenseOwner: "",
    destination: "",
  });

  const datas = location.state;
  // console.log("slip datas", datas);
  const token = window.localStorage.getItem("token");
  const license = datas?.newData?.license;

  const handleCreateInvoice = (datas: any) => {
    navigate("/dashboard/generatedslip", { state: datas });
    // console.log("new datas:", datas);
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
  const [getTransport, setgetTransport] = useState<Transport[]>([]);

  const [selectMvt, setSelectMvt] = useState("");
  const [selectedDriverId, setSelectedDriverId] = useState<string>("");

  const selectedDriverDetails = getTransport.find(
    (driver) => driver._id === selectedDriverId
  );

  const handleDriverChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedDriverId(e.target.value);
  };

  const handleTransporterChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedValue = e.target.value;
    setSelectMvt(selectedValue);
    // console.log(selectMvt);
  };

  const handleClick = () => {
    const dataWithDriver = {
      ...datas,
      selectMvt,
      selectedDriverDetails,
    };
    handleCreateInvoice(dataWithDriver);
  };

  function queryTransport() {
    return api
      .get("/registered-trucks", {
        headers: headers,
      })
      .then((res) => {
        setgetTransport(res.data.data);
        // console.log("driver", res.data.data);
      })
      .catch((error) => {
        if (
          error.response?.data?.message === "jwt expired" ||
          error.response?.data?.message === "jwt malformed"
        ) {
          toast.error('Session expired, please log in again.');
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error.response.data.message);
      });
  }

  useEffect(() => {
    queryTransport();
  }, []);

  const getLicenseData = () => {
    if (!license) {
      return Promise.resolve(null); // Return resolved promise if no license
    }
    return api
      .get(`/license/${license}`, {
        headers: headers,
      })
      .then((res) => {
        // console.log("fetched license data:", res.data.data);
        setLicenseData({
          licenseId: res.data.data.licenseId || "",
          licenseOwner: res.data.data.licenseOwner || "",
          destination: res.data.data.destination || "",
        });
        return res.data.data;
      })
      .catch((error) => {
        if (
          error.response?.data?.message === "jwt expired" ||
          error.response?.data?.message === "jwt malformed"
        ) {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error.response.data.message);
      });
  };

  useEffect(() => {
    getLicenseData()
      .then((licenseData) => {
        // No action needed here since state is set in getLicenseData
      })
      .catch((error) => {
        console.error("Error fetching license data:", error);
      });
  }, [license]);

  return (
    <div className="board">
      <TopNav title="Loading Slip" />
      <ToastContainer />
      {reLogin ? <ReLoginModal /> : null}

      <BsArrowLeft
        style={{
          cursor: "pointer",
          fontSize: "30px",
          marginLeft: "2em",
          marginTop: "1em",
        }}
        onClick={() => navigate("/dashboard/loadingslip")}
      />
      <div className="loadingSlip">
        <h2>Generate Loading Slip</h2>

        <div className="generateSlip">
          <div className="slipPages">
            <div className="singleSlip">
              {datas?.newData?.loadingType === "single" ? (
                <p>Slip based on Single Approval</p>
              ) : (
                <p>Slip based on Multiple Approvals</p>
              )}
            </div>
            <div className="sLine"></div>
            {licenseData.licenseId && (
              <div className="singleSlip">
                <p className="text-center font-weight-800 mb-4 underline">Licence being used</p>
                <table className="w-full bg-white shadow-lg rounded-lg overflow-hidden border border-gray-200">
                  <tbody className="divide-y divide-gray-100">
                    <tr className="hover:bg-gray-50 transition-colors duration-150">
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 bg-gray-50 border-r border-gray-200">
                        <p className="flex items-center">
                          <span className="w-2 h-2 bg-blue-500 rounded-full mr-2"></span>
                          License owner:
                        </p>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        <p className="font-semibold">{licenseData.licenseOwner}</p>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition-colors duration-150">
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 bg-gray-50 border-r border-gray-200">
                        <p className="flex items-center">
                          <span className="w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                          License number:
                        </p>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        <p className="font-semibold font-mono bg-gray-100 px-2 py-1 rounded text-xs inline-block">
                          {licenseData.licenseId}
                        </p>
                      </td>
                    </tr>
                    <tr className="hover:bg-gray-50 transition-colors duration-150">
                      <td className="px-6 py-4 text-sm font-medium text-gray-900 bg-gray-50 border-r border-gray-200">
                        <p className="flex items-center">
                          <span className="w-2 h-2 bg-purple-500 rounded-full mr-2"></span>
                          Destination:
                        </p>
                      </td>
                      <td className="px-6 py-4 text-sm text-gray-700">
                        <p className="font-semibold flex items-center">
                          <svg className="w-4 h-4 text-purple-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          {licenseData.destination}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="slipInfo">
            <div className="infoTop">
              <div>
                <div className="RequiName">
                  <h2>AP</h2>
                  <div className="reName">
                    <p>Business Name</p>
                    <span>{datas?.originalData?.customer.businessName}</span>
                    {/* <span>Lagos Nigeria</span> */}
                  </div>
                </div>
                <p>
                  Requisition Number:
                  {datas?.newData?.requisitions.map((id: any) => id.approvalNumber).join(", ")}
                </p>
              </div>
              <div>
                <p>Loading Number</p>
                <p> {datas?.newData?.requisitions.map((id: any) => id._id).join(", ")}</p>
              </div>
            </div>

            <div className="slipTable">
              <table>
                <tr>
                  <th>Item Name</th>
                  <th>Require Quantity</th>
                  <th>Unit Price</th>
                  <th>Total Cost</th>
                  <th>Quantity to load</th>
                  <th>Available to book</th>
                </tr>
                {datas?.newData?.requisitions.map((details: any, inx: number) => {
                  return (
                    <tr key={inx}>
                      <td>{details.itemName}</td>
                      <td>{details?.quantity}</td>
                      <td>{details?.unitPrice}</td>
                      <td>{details?.totalCost}</td>
                      <td>{details?.quantityToLoad}</td>
                      <td>{details?.availableToBook}</td>
                    </tr>
                  );
                })}
              </table>
            </div>
            <div className="deli">
              <div className="input">
                <label>Select MVT</label>
                <select name="transporter" onChange={handleTransporterChange}>
                  <option value="">MVT </option>
                  <option value="TRANSPORTER">Transport</option>
                  <option value="SELF COLLECTION">Self Collection</option>
                </select>
              </div>
              {selectMvt === "TRANSPORTER" ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gap: "1em",
                  }}
                >
                  <div className="input">
                    <label>Select Driver</label>
                    <select
                      name="selectedDriver"
                      id="selectedDriver"
                      value={selectedDriverId}
                      onChange={handleDriverChange}
                    >
                      <option value="">Select a Driver</option>
                      {getTransport.map((trans) => (
                        <option key={trans._id} value={trans._id}>
                          {trans.driver}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              ) : null}
              <div></div>
            </div>

            <div className="print">
              <button onClick={handleClick}>Print Slip</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Slip;